<template>
  <div class="airlines-pricelist">
    <!-- <div class="airlines-pricelist__title"><h1 class="medium-title">Price List</h1></div> -->
    <div class="airlines-pricelist__header" @click="closeModal()">
      <div class="airlines-pricelist__header__left">
        <div class="search">
          <i class="adx-ic_search"></i>
          <input
            v-model="searchBoxValue"
            type="text"
            placeholder="Search placement or location ..."
          />
        </div>
        <a-dropdown-checkbox
          class="brand-dropdown"
          :color="`pink`"
          :list="brandNames"
          :loading="isLoadingBrand"
          @selected="selectedBrand"
          labelButton="Brand"
          :value.sync="selectedBrandValue"
          :default="selectedBrandValue"
        ></a-dropdown-checkbox>
        <a-dropdown-checkbox
          class="mediatype"
          :color="`pink`"
          :list="monthPeriod"
          :loading="isLoadingMinimum"
          @selected="selectedDropdown"
          labelButton="Minimum Order"
          :value.sync="selectedPeriodValue"
          :default="selectedPeriodValue"
        ></a-dropdown-checkbox>
        <div v-if="filtered" class="reset">
          <button class="btn-regular link" @click="resetFilter">Reset</button>
        </div>
      </div>
      <div class="airlines-pricelist__header__right">
        <!-- Waiting for approval -->
        <!-- <div class="airlines-pricelist__header__right__date">
          <div class="airlines-pricelist__header__right__date__label">Date :</div>
          <v-date-picker class="airlines-pricelist__header__right__date__calendar" mode='range' :popoverVisibility="'focus'" :theme-styles='themeStyles'
            popover-align="right" v-model='myRange' :min-date="minDate" :attributes='attributes' is-double-paned :show-day-popover="false" show-caps>
            <input class="calendar-base" type='text' slot-scope='{ inputValue, updateValue }' disabled :value='inputValue'
              @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
              @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'>
          </v-date-picker>
        </div>-->
        <div class="airlines-pricelist__header__right__sort">
          <div class="airlines-pricelist__header__right__sort__label">Sort by:</div>
          <a-dropdown-sort
            class="airlines-pricelist__header__right__sort__dropdown"
            :value.sync="selectedSortValue"
            :type="true"
            :options="sortOptions"
          ></a-dropdown-sort>
        </div>
      </div>
    </div>
    <div class="airlines-pricelist__table" @click="closeModal()">
      <div>
        <table class="table-pricelist">
          <thead>
            <tr>
              <th>
                <span class="btn-header"></span>
              </th>
              <th class="brand-header mini-font">BRANDS</th>
              <th class="item-header mini-font">ITEMS</th>
              <th>
                <div class="items">
                  <span class="mini-font">CATEGORIES</span>
                </div>
              </th>
              <th>
                <div class="items">
                  <span class="mini-font">MIN ORDER</span>
                  <i class="adx-ic_info"></i>
                </div>
              </th>
              <th>
                <div class="items">
                  <span class="mini-font">PRICE</span>
                </div>
              </th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody v-if="!isLoading && !isEmpty">
            <tr v-for="(item, index) in items" :key="index" @click.stop="selectedRow(item, index)">
              <td @click.stop="selectItem(item.id)">
                <span :class="isSelected(item.id) ? 'adx-ic_check' : 'adx-ic_plus'"></span>
              </td>
              <td>
                <span class="subhead">{{ item.airlines.brand.name }}</span>
              </td>
              <td>
                <div class="item-section">
                  <span class="placement-name subhead strong">{{ item.name }}</span>
                  <span class="location-name subhead">{{ item.location_data.name }}</span>
                </div>
              </td>
              <td>
                <span class="min-period subhead">{{ item.airlines.category }}</span>
              </td>
              <td>
                <span
                  class="min-period subhead"
                >{{ minOrder(item.min_period, item.min_period_unit) }}</span>
              </td>
              <td>
                <span class="public-price subhead strong">{{ item.calculated_public_price | formatMoney }}</span>
              </td>
              <td v-if="item.future_prices.length > 0">
                <adx-tooltip
                  :text="getFuturePriceStart(item.future_prices[0].start)"
                  :isLong="true"
                >
                  <span slot="content">
                    <div class="futureprice">
                      <img src="/img/icons/ic-info-color-@3x 2.png" />
                    </div>
                  </span>
                </adx-tooltip>
              </td>
              <td v-else></td>
              <td>
                <a-menu-expansion
                  :itemID="item.id"
                  :lists="menuExpansionList"
                  @selected="selected"
                />
              </td>
            </tr>
            <tr></tr>
            <tr></tr>
            <tr></tr>
          </tbody>
          <tbody v-else-if="!isLoading && isEmpty" class="emptyLoadingState">
            <tr>
              <td colspan="100">
                <a-emptystate />
              </td>
            </tr>
          </tbody>
          <tbody v-else-if="isLoading" class="emptyLoadingState">
            <tr>
              <td colspan="100">
                <a-loading />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <a-pagination
        v-if="!isLoading && !isEmpty"
        :selectedPage="selectedPage"
        :maxPage="maxPage"
        @change-page="selectPage"
      />
    </div>
    <a-modal
      v-if="isShowModal"
      @modal-close="toggleModal('isShowModal')"
      class="airlines-pricelist__modal"
      :noTitle="true"
    >
      <div slot="content">
        <div class="airlines-pricelist__modal__wrapper">
          <h1 class="medium-title title">Placement Detail</h1>
          <div class="airlines-pricelist__modal__wrapper__header">
            <div class="airlines-pricelist__modal__wrapper__header__top">
              <h1 class="regular-font">{{modal.placement}}</h1>
              <div>Price</div>
            </div>
            <div class="airlines-pricelist__modal__wrapper__header__bottom">
              <div class="subhead">{{modal.brand.name}}, {{modal.media}}</div>
              <h1 class="subhead price">{{modal.publicPrice | formatMoney}}</h1>
            </div>
          </div>
          <div class="airlines-pricelist__modal__wrapper__body">
            <div class="airlines-pricelist__modal__wrapper__body__tab">
              <ul>
                <router-link tag="li" :to="{name: 'airlinesdetail'}" class="subhead">Detail</router-link>
                <router-link
                  tag="li"
                  :to="{name: 'airlinescontentrest'}"
                  class="subhead"
                >Item Details</router-link>
                <router-link tag="li" :to="{name: 'airlinesfutureprice'}" class="subhead">Pricing</router-link>
                <!-- <router-link tag="li" :to="{name: 'airlinesimages'}" class="subhead">Images</router-link> -->
              </ul>
            </div>
            <div class="airlines-pricelist__modal__wrapper__body__detail">
              <router-view :placementId="placementId" />
            </div>
            <div class="airlines-pricelist__modal__wrapper__body__close">
              <button class="btn-large secondary" @click="toggleModal('isShowModal')">Close</button>
            </div>
          </div>
        </div>
      </div>
    </a-modal>
    <a-modal
      v-if="isShowConfirmationModal"
      @modal-close="toggleModal('isShowConfirmationModal')"
      class="airlines-pricelist__confirmation-modal"
      :noTitle="true"
    >
      <div slot="content">
        <div class="airlines-pricelist__confirmation-modal__wrapper">
          <h1 class="medium-title title">Remove item from Order?</h1>
          <p
            class="subhead"
          >It seems you have items on order summary, if you move to other channel all items will be removed, are you sure to continue?</p>
          <p class="subhead">Note: 1 channel only possible added as 1 campaign.</p>
          <div class="airlines-pricelist__confirmation-modal__wrapper__buttons">
            <button
              type="button"
              class="btn-block secondary"
              @click.stop="redirectPage"
            >Continue, and Remove Item</button>
            <button
              type="button"
              class="btn-block primary"
              @click.stop="toggleModal('isShowConfirmationModal')"
            >Cancel</button>
          </div>
        </div>
      </div>
    </a-modal>
    <div v-if="isShowList" class="airlines-pricelist__order">
      <i class="icon-close" @click="toggleModal('isShowList')"></i>
      <h1 class="smedium-title">Summary</h1>
      <div class="airlines-pricelist__order__wrapper">
        <div
          class="airlines-pricelist__order__wrapper__row"
          v-for="(selectedItem, index) in selectedItems"
          :key="index"
        >
          <div class="airlines-pricelist__order__wrapper__row__left">
            <div class="placement subhead">{{selectedItem.name}}</div>
            <div class="location">{{selectedItem.location_data.name}}</div>
          </div>
          <div class="airlines-pricelist__order__wrapper__row__right">
            <span class="price subhead">{{selectedItem.calculated_public_price | formatMoney }}</span>
            <span class="delete">
              <i @click="removeSelectedItems(selectedItem.id)" class="icon-deleted"></i>
            </span>
          </div>
        </div>
      </div>
      <div class="airlines-pricelist__order__total">
        <div class="airlines-pricelist__order__total__row">
          <div class="title subhead">PPN 10%</div>
          <div class="price subhead">{{totalPrice - totalPriceBeforeTax | formatMoney}}</div>
        </div>
        <div class="airlines-pricelist__order__total__row">
          <div class="title subhead">Est. Total Price</div>
          <span class="price subhead">{{totalPrice | formatMoney }}</span>
        </div>
        <div
          class="airlines-pricelist__order__total__note"
        >* This Price only estimation, before including Discount and etc</div>
      </div>
    </div>
    <div class="airlines-pricelist__footer">
      <div class="airlines-pricelist__footer__wrapper">
        <div class="airlines-pricelist__footer__wrapper__left">
          <h1 class="selected">{{this.selectedItems.length}} Selected Advertising</h1>
        </div>
        <div class="airlines-pricelist__footer__wrapper__right">
          <div class="airlines-pricelist__footer__wrapper__right__total-price">
            <div class="total">
              <span>Est. Total Price</span>
            </div>
            <div class="price">
              <span>{{ totalPrice | formatMoney }}</span>
            </div>
          </div>
          <div class="airlines-pricelist__footer__wrapper__right__buttons">
            <button class="btn-large secondary" @click="toggleModal('isShowList')">View List</button>
            <button class="btn-large primary save" @click="createCampaign">
              <div>
                <span class="color-white btn"> Create Campaign </span>
                <span><adx-loading-secondary-white class="sk-circle" v-if="isLoadingSave" /></span>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import api from "@/api";
import { restEdge } from "@/api/edgeUrls";
import { globalMixins } from "@/lib/mixins/globalMixins";
import { helpers } from "@/lib/validation/";
import { mapGetters } from "vuex";

import table from "@/components/Table";
import Pagination from "@/components/Pagination";
import Tooltip from "@/components/Tooltip";
import LoadingSecondaryWhite from "@/components/Loading/Secondary-white";

import { formatShortDate } from "@/lib/util";
import { formatMonetization } from "@/lib/filter";
import { fromArrayKeysName, fromKeys, mapListFilter } from "@/lib/transformer";

import {
  ASelectDropdown,
  ALoadingPrimary,
  AModal,
  APagination,
  ATable,
  AListDropdown,
  ACheckboxDropdownCustom,
  AEmptySelection,
  AMenuExpansion
} from "ui-kit-v1";

export default {
  name: "adx-pricelist-airlines",
  components: {
    "a-table": ATable,
    "a-pagination": APagination,
    "a-dropdown-sort": ASelectDropdown,
    "a-modal": AModal,
    "a-loading": ALoadingPrimary,
    "adx-loading-secondary-white": LoadingSecondaryWhite,
    "a-dropdown-list": AListDropdown,
    "a-dropdown-checkbox": ACheckboxDropdownCustom,
    "a-emptystate": AEmptySelection,
    "a-menu-expansion": AMenuExpansion,
    "adx-tooltip": Tooltip
  },
  mixins: [globalMixins],
  props: {},
  data() {
    return {
      items: [],
      ids: [],
      maxPage: 1,
      selectedPage: 1,
      placementId: null,
      isShowModal: false,
      isShowList: false,
      isShowConfirmationModal: false,
      nextUrl: null,
      item: null,
      isLoading: false,
      isLoadingSave: false,
      isLoadingBrand: false,
      isLoadingMinimum: false,
      isEmpty: false,
      searchBoxValue: null,
      selectedSortValue: "last_added",
      token_req: null,
      monthPeriod: [],
      brandNames: [],
      minDate: new Date(
        moment()
          .utcOffset(7)
          .format("YYYY-MM-DD")
      ),
      maxDate: new Date(
        moment()
          .utcOffset(7)
          .add(14, "days")
          .format("YYYY-MM-DD")
      ),
      selectedItems: [],
      myRange: {
        start: new Date(moment().utcOffset(7)),
        end: new Date(
          moment()
            .utcOffset(7)
            .add(1, "months")
        )
      },
      themeStyles: {
        dayContent: {
          fontSize: "15px"
        },
        headerTitle: {
          fontSize: "17px",
          fontWeight: "bold"
        },
        weeks: {
          fontWeight: "bold"
        },
        wrapper: {
          boxShadow: "0 1px 4px 0 #f0f0f3",
          backgroundColor: "white",
          border: "none"
        },
        header: {
          marginBottom: "6px"
        },
        dayCellNotInMonth: {
          opacity: 0
        }
      },
      attributes: [
        {
          dates: [],
          highlight: {
            backgroundColor: "#ff3b30"
          }
        },
        {
          dates: [],
          dot: {
            backgroundColor: "#ff3b30"
          }
        }
      ],
      sortOptions: [
        {
          label: "Last Added",
          value: "last_added"
        },
        {
          label: "Highest Price",
          value: "price"
        },
        {
          label: "Lowest Price",
          value: "lowest_price"
        },
        {
          label: "Name",
          value: "name"
        }
      ],
      tableData: {
        checkbox: true,
        menu: [
          {
            id: 0,
            name: "Add to existing campaign",
            value: "S",
            items: []
          }
        ],
        head: [
          {
            title: "ID",
            type: "text",
            display: "display: none;"
          },
          {
            title: "ITEMS",
            type: "description"
          },
          {
            title: "MIN.ORDER",
            type: "text"
          },
          {
            title: "PRICE",
            type: "money"
          },
          {
            title: "FUTURE PRICE",
            type: "multipletext"
          }
        ],
        body: []
      },
      tableIds: [],
      modal: {
        media: null,
        placement: null,
        publicPrice: null,
        brand: null,
      },
      totalPrice: null,
      totalPriceBeforeTax: null,
      selectedItems: [],
      listItems: [],
      selectedPeriodValue: [],
      selectedBrandValue: [],
      selectedPeriodLabel: "",
      menuExpansionList: [
        {
          id: 0,
          name: "Add to existing campaign",
          value: "S",
          items: []
        }
      ]
    };
  },
  computed: {
    ...mapGetters({
      userId: "userId"
    }),
    filtered: function() {
      let filtered = false;
      if (this.selectedPeriodValue.length > 0 || this.selectedBrandValue.length > 0) {
        filtered = true;
      }
      return filtered;
    }
  },
  watch: {
    searchBoxValue: helpers.debounce(function() {
      this.$nextTick(() => {
        this.selectedPage = 1;
        this.loadData();
      });
    }, 500),
    selectedSortValue: function() {
      this.loadData();
    },
    selectedPage: function() {
      this.loadData();
    },
    myRange: {
      handler: function() {},
      deep: true
    },
    selectedPeriodValue: function() {
      this.$nextTick(() => {
        this.selectedPage = 1
        this.loadData();
      });
    },
    selectedBrandValue: function() {
      this.$nextTick(() => {
        this.selectedPage = 1
        this.loadData();
      });
    }
  },
  beforeCreate() {},
  created() {
    this.loadFilter();
    this.loadBrand()
    this.loadCampaign();
    this.loadData();
  },
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  beforeRouteLeave(to, from, next) {
    if (this.selectedItems.length > 0 && to.name != "campaigneditoredit") {
      this.toggleModal("isShowConfirmationModal");
      this.nextUrl = to.name;
    } else {
      next();
    }
  },
  methods: {
    minOrder(minPeriod, minPeriodPlan) {
      return `${minPeriod} ${minPeriodPlan}`;
    },
    getFuturePriceStart(date) {
      let start = moment(date, "YYYY-MM-DD");
      return `Future Price Applied on ${start.format("DD MMM YYYY")}`;
    },
    isSelected(id) {
      return this.ids.includes(id);
    },
    async loadFilter() {
      this.isLoadingMinimum = true
      const { data, status } = await api.get(restEdge.airlinesFilter,{ 
      needToken: true, 
      useRestEdge: true 
      });
      if (status === 200) {
        this.monthPeriod = mapListFilter({
            obj: data.periods,
            id: `id`,
            value: `value`,
            label: `name`
        });
      }
      this.isLoadingMinimum = false
    },
    async loadCampaign() {
      let params = {
        channel: "airlines"
      };
      const { data, status } = await api.get(restEdge.getAllCampaignChannel, {
        params: params,
        needToken: true,
        useRestEdge: true
      });

      this.tableData.menu[0].items = data.map(x => {
        return {
          label: x.name,
          value: "expired",
          id: x.id
        };
      });

      this.menuExpansionList[0].items = data.map(x => ({
        name: x.name,
        id: x.id
      }));
    },
    async loadBrand(){
      this.isLoadingBrand = true
      let params = { channel: 'airlines' };
      const { data, status } = await api.get(restEdge.airlineBrand, {
        params: params,
        needToken: true,
        useRestEdge: true
      });

      data.map(brand => {
        this.brandNames.push({
          id: brand.id,
          label: brand.name,
          value: brand.id
        });
      });
      this.isLoadingBrand = false
    },
    async loadData() {
      this.isLoading = true;
      this.isEmpty = false;
      this.tableIds = [];
      let params = {
        page: this.selectedPage,
        search: this.searchBoxValue,
        sort: this.selectedSortValue,
        min_periods: this.selectedPeriodValue.join(",") || undefined,
        brands: this.selectedBrandValue.join(",") || undefined,
      };

      let random_numb = Math.random()
      this.token_req = random_numb;

      const { data, status } = await api.get(restEdge.airlinesPricelist, {
        params: params,
        needToken: true,
        useRestEdge: true
      });

      if (status === 200) {
        if (random_numb == this.token_req) {
          this.listItems = data.results;
          this.tableData.body = await data.results.map(result => {
            this.tableIds.push(result.id);

            let rowData = {
              values: [
                { value: result.id, display: "display: none;" },
                {
                  header: true,
                  items: [
                    { value: result.name },
                    { value: result.location_data.name }
                  ],
                  labelLink: true,
                  label: "View Detail"
                },
                {
                  value: this.pluralize(result.min_period, result.min_period_unit)
                },
                { value: result.public_price }
              ]
            };

            if (result.future_prices.length) {
              rowData.values.push({
                items: [
                  {
                    value: formatMonetization(
                      result.future_prices[0].public_price
                    )
                  },
                  {
                    value:
                      "Applied " + formatShortDate(result.future_prices[0].start)
                  }
                ]
              });
            } else {
              rowData.values.push({
                items: [{ value: "-" }]
              });
            }

            return rowData;
          });

          this.items = data.results;
          this.items.forEach(item => {
            this.tableIds.push(item.id);
          });
          this.maxPage = data.maxPage;
          if (!this.tableData.body.length) this.isEmpty = true;
        }
      } else {
        this.showNotificationAlert(
          "Error",
          "Ops, something went wrong.",
          "danger"
        );
      }
      this.isLoading = false;
    },
    async selectedRow(item, index) {
      this.toggleModal("isShowModal");
      this.placementId = this.tableIds[index];

      this.modal.brand = item.airlines.brand
      this.modal.placement = item.name;
      this.modal.media =
        item.location_data != null || item.location_data != undefined
          ? item.location_data.name
          : "-";
      this.modal.publicPrice = item.calculated_public_price;
      // this.modal.placement = item.values[1].items[0].value;
      // this.modal.media = item.values[1].items[1].value;
      // this.modal.publicPrice = item.values[3].value;
    },
    toggleModal(value) {
      this.$data[value] = !this.$data[value];
      if (!this.showModal) {
        this.$router.push({ name: "airlinesdetail" });
      }
    },
    closeModal(){
      this.isShowList = false
    },
    selectPage(item) {
      this.selectedPage = item;
    },
    pluralize(value, label) {
      if (value > 1) {
        return `${value} ${label}s`;
      }

      return `${value} ${label}`;
    },
    selectedInput(index, item, value) {
      let val = this.tableData.body[index].values[3].value;
      let bottomPrice = this.tableData.body[index].values[2].value;

      //calculating discount inputed to given price
      this.tableData.body[index].values[5].value = val - (value / 100) * val;

      //validating if given price npt lower than bottom price
      if (this.tableData.body[index].values[5].value < bottomPrice) {
        this.tableData.body[index].values[4].isError = true;
      } else {
        this.tableData.body[index].values[4].isError = false;
      }
      return (this.discount = parseInt(value));
    },
    selectedCheckbox(id) {
      if (this.ids.includes(id)) {
        let index = this.ids.indexOf(id);
        this.ids.splice(index, 1);
      } else {
        this.ids.push(id);
      }
      this.selectedItems = this.listItems.filter(item =>
        this.ids.includes(item.id)
      );
      this.computeTotalPrice();
    },
    selectItem(id) {
      if (this.ids.includes(id)) {
        let index = this.ids.indexOf(id);
        this.ids.splice(index, 1);
        this.selectedItems = this.selectedItems.filter(function(value, index, arr){ return value.id !== id;});
      } else {
        this.ids.push(id);
        this.selectedItems.push(...this.listItems.filter(item =>
          id == item.id
        ))
      }
      
      this.computeTotalPrice();
    },
    removeSelectedItems(id) {
      this.selectedItems = this.selectedItems.filter(item => item.id !== id)
      this.ids = this.ids.filter(itemId => itemId != id)
      this.computeTotalPrice();
    },
    computeTotalPrice() {
      this.totalPrice = 0;
      this.totalPriceBeforeTax = 0;
      if (this.selectedItems.length) {
        this.totalPriceBeforeTax = this.selectedItems.reduce(
          (total, item) => total + item.calculated_public_price,
          0
        );
        this.totalPrice = (this.totalPriceBeforeTax * 110) / 100;
      }
    },
    async createCampaign() {
      this.isLoading = true;
      this.isLoadingSave = true;
      if (this.selectedItems.length) {
        let body = {
          campaign_medias: [],
          owner: this.userId,
          channel: this.selectedItems[0].location_data.channel
        };

        this.selectedItems.forEach(item => {
          if (!body.campaign_medias.length) {
            body.campaign_medias.push({
              list_item: [{id: item.id}]
            });
          } else {
            body.campaign_medias[0].list_item = [
              ...body.campaign_medias[0].list_item,
              {id: item.id}
            ];
          }
        });

        const { data, status } = await api.post(
          restEdge.createCampaignChannel,
          body,
          { needToken: true, useRestEdge: true }
        );
        if (status === 200) {
          this.$router.push({
            name: "campaigneditoredit",
            params: { id: data.id }
          });
        } else {
          this.showNotificationAlert(
            "Error",
            "Ops, something went wrong.",
            "danger"
          );
        }
      } else {
        this.showNotificationAlert(
          "Error",
          "Please select a placement.",
          "danger"
        );
      }
      this.isLoading = false;
      this.isLoadingSave = false;
    },
    async selected(event) {
      const item = this.listItems.filter(x => x.id == event.item_id).pop();
      const body = {
        campaign_medias: [
          {
            // media_items: [item.id],
            // media_type: item.media_type,
            list_item: [{ id: item.id }]
          }
        ]
      };

      const { data, status } = await api.patch(
        restEdge.patchCampaignChannel(event.items.id),
        body,
        { needToken: true, useRestEdge: true }
      );

      if (status === 200) {
        this.showNotificationAlert(
          "Success",
          `Data successfully added to campaign ${data.name}!`,
          "success"
        );
      } else if (status == 400) {
        this.showNotificationAlert(
          "Error",
          "Placement already exist.",
          "danger"
        );
      } else {
        this.showNotificationAlert(
          "Error",
          "Ops, something went wrong.",
          "danger"
        );
      }
    },
    selectedMediaType(item) {
      this.selectedPeriodValue = item.value;
      this.selectedPeriodLabel = item.id.toString();
    },
    selectedDropdown(items) {
      this.selectedPeriodValue = items;
    },
    selectedBrand(items) {
      this.selectedBrandValue = items;
    },
    resetFilter() {
      this.selectedPeriodValue = [];
      this.selectedBrandValue = []
    },
    redirectPage() {
      this.selectedItems = [];
      this.$router.push({ name: this.nextUrl });
    }
  }
};
</script>

<style lang='scss' scoped>
@import "./index.scss";
</style>

<style lang="scss">
@import "~@/styles/variables";

.airlines-pricelist {
  tbody {
    tr {
      cursor: pointer;
      td {
        .inputed-type {
          width: 140px !important;
        }

        .money {
          text-align: left !important;
          span {
            color: #ff2d55;
            font-size: 15px;
            font-weight: bold;
          }
        }

        .text {
          font-size: 15px;
        }

        .description {
          max-width: unset !important;

          b {
            font-size: 17px;
          }
          span {
            font-size: 15px;
          }
          .label_hover {
            span {
              font-size: 15px;
            }
          }
        }

        .multiple-text {
          div {
            &:nth-child(1) {
              span {
                font-size: 15px;
                color: $warm-grey;
              }
            }

            &:nth-child(2) {
              span {
                font-size: 12px;
                color: $sunflower-yellow;
              }
            }
          }
        }

        input {
          border: 1px solid lightgray;
          border-radius: 4px;
          padding: 8px;
          margin-bottom: 8px;
          width: 140px;
          // max-width: 130px;
        }

        .error-message {
          width: 140px !important;
        }
      }
    }
  }

  .table input {
    width: 140px !important;
  }

  .table table tbody tr td .multiple-text div {
    margin-bottom: 2px !important;
  }

  .table table tbody tr td .description {
    max-width: unset;
    min-width: 280px;
  }

  .status-label .label {
    margin: 0px !important;
  }

  // .modal__content {
  //   width: 50%;
  //   max-height: 550px;
  //   overflow: auto;
  // }

  .menuexpansion__level1__item {
    width: 230px;
  }

  .menuexpansion__level2__wrapper {
    overflow-x: hidden;

    li:first-child {
      border-bottom: none;
    }

    .status-label {
      white-space: normal;

      .label {
        background-color: transparent;
        color: $black;
        width: 150px;
        word-wrap: break-word;
      }
    }
  }
}

.futureprice {
  height: 16px;
  width: 16px;
  margin-top: 7px;
}

.dropdown.brand-dropdown {
    margin-right: 10px;
}
</style>
